/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Vekn_Tournaments_LabelInputs */



/**
* | output |
* | --- |
* | "Sync VEKN tournaments" |
*
* @param {Admin_Sync_Vekn_Tournaments_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_vekn_tournaments_label = /** @type {((inputs?: Admin_Sync_Vekn_Tournaments_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Vekn_Tournaments_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser les tournois VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar torneos de VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronizar torneios do VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza i tornei VEKN")
	return /** @type {LocalizedString} */ ("Sync VEKN tournaments")
});